import { serviceHandler } from './service-executor';

const INVOICE_URL = '/api/invoices';

export const search = (invoiceStatus, params, page, pageSize) => {
  const URL = `${INVOICE_URL}/all?paymentStatus=${invoiceStatus}&page=${page}&pageSize=${pageSize}`;
  return serviceHandler(URL, 'POST', params);
};

export const list = (invoiceStatus, params, page, pageSize) => {
  const URL = `${INVOICE_URL}/${invoiceStatus}?page=${page}&pageSize=${pageSize}`;
  return serviceHandler(URL, 'POST', params);
};

export const save = invoice => {
  const URL = `${INVOICE_URL}/save`;
  return serviceHandler(URL, 'POST', invoice);
};

export const update = invoice => {
  const URL = `${INVOICE_URL}/update`;  
  return serviceHandler(URL, 'POST', invoice);
};

export const getInvoiceById = (invoiceId) => {
  const URL = `${INVOICE_URL}/${invoiceId}`;
  return serviceHandler(URL, 'GET');
};

export const viewInvoiceReport = (orderIds, reportDate) => {
  const idStr = orderIds.join();
  const URL = `/api/invoices/${idStr}/report?reportDate=${reportDate}`;
  return serviceHandler(URL, 'GET_BLOB');
};

export const generateInvoice = (invoiceIdList) => {
  const idStr = invoiceIdList.join();
  const URL = `/api/invoices/${idStr}/generate`;
  return serviceHandler(URL, 'GET');
};

export const unInvoice = (invoiceIdList) => {
  const idStr = invoiceIdList.join();
  const URL = `/api/invoices/${idStr}/uninvoice`;
  return serviceHandler(URL, 'GET');
};

export const processInvoicePayment = (payment) => {
  const URL = '/api/invoices/pay';
  return serviceHandler(URL, 'POST', payment);
};

export const saveCheck = (invoiceId, check) => {
  const URL = `${INVOICE_URL}/${invoiceId}/check/save`;
  return serviceHandler(URL, 'POST', check);
};

export const viewFactoringInvoice = (orderIds) => {
  const idStr = orderIds.join();
  const URL = `${INVOICE_URL}/${idStr}/factoring/preview`;
  return URL;
};

export const printFactoringInvoice = (orderIds) => {
  const idStr = orderIds.join();
  const URL = `${INVOICE_URL}/${idStr}/factoring/printed`;
  return serviceHandler(URL, 'GET_BLOB');
};

export const getInvoiceCountsByStauts = (status) => {
  const URL = `${INVOICE_URL}/status/${status}`;
  return serviceHandler(URL, 'GET');
};

export const getInvoiceCounts = () => {
  const URL = `${INVOICE_URL}/counts`;
  return serviceHandler(URL, 'GET');
};